'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "MessageIndicatorWrapper": "Polaris-MessageIndicator__MessageIndicatorWrapper",
  "MessageIndicator": "Polaris-MessageIndicator"
};

exports.default = styles;
